(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["movelio-daily-cost"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('movelio-daily-cost')) {
    customElements.define('movelio-daily-cost', class extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.updateCost = () => {
          const input = this.form?.querySelector('[name="id"]');
          if (!input) return;
          this.querySelectorAll('[data-variant-id]').forEach(row => {
            row.hidden = row.dataset.variantId !== input.value;
          });
        };
        this.form?.addEventListener('change', this.updateCost);
        this.updateCost();
      }
      disconnectedCallback() {
        this.form?.removeEventListener('change', this.updateCost);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
